export default IconTornado => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-tornado" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M21 4l-18 0" />
  <path d="M13 16l-6 0" />
  <path d="M11 20l4 0" />
  <path d="M6 8l14 0" />
  <path d="M4 12l12 0" />
</svg>`;